import React, { useState, useEffect, Fragment, useMemo } from "react";

import {
  Box,
  Grid,
  TextField,
  FormControl,
  Autocomplete,
  LinearProgress,
  Fade,
  FormLabel,
} from "@mui/material";
import { Button } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";

import {
  CommonSubHeader,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";
import { Topic } from "@mui/icons-material";
import api from "../../api/axios";

const Editar = () => {
  const navigate = useNavigate();

  const { goPanel, goTable, goView } = useLocationHelpers();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("id");

  const Swal = require("sweetalert2");
  const [flagCompanySelected, setFlagCompanySelected] = useState(true);
  const [userLogged, setUserLogged] = useState(0);

  // Estados para abrir las opciones y sus datos
  const [openOptions, setOpenOptions] = useState({
    userRol: false,
    companies: false,
    // offices: false,
    provinces: false,
    associations: false,
    zones: false,
    status: false,
  });

  const [options, setOptions] = useState({
    userRol: [],
    companies: [],
    // offices: [],
    provinces: [],
    associations: [],
    zones: [],
    status: [],
  });

  // Loading Options
  const loadingOptions = Object.fromEntries(
    Object.entries(openOptions).map(([key, value]) => [
      key,
      value && (options[key] ? options[key].length === 0 : true),
    ]),
  );

  // Toma de valores
  const [formValues, setFormValues] = useState({
    userRolId: "",
    companyId: "",
    // office: "",
    userEmail: "",
    userName: "",
    userSurname: "",
    userAddress: "",
    userPostalCode: "",
    userDocument: "",
    userPhone: "",
    provinceName: "",
    association: "",
    zonesId: "",
    userTasks: "",
    valCaseTypeForm: "",
  });

  const [flag, setFlag] = useState(false);

  // GET DATA LIST
  const getDataList = async (actualUrl) => {
    setFlag(true);
    const url = `${actualUrl}/editlawyer`;

    try {
      const response = await api.post(url, { id: userId });
      const { companies, provinces, lawyer, roles, user_logged } =
        response.data;

      const defaultOptions = { id: 0 };

      console.log(response);

      let user_task = [
        { nombre: "Ninguno", id: 0 },
        { nombre: "Abogado", id: 1 },
        { nombre: "Perito", id: 2 },
      ];

      for (let i = 0; i < user_task.length; i++) {
        if (user_task[i].id == lawyer[0].is_lawyer) {
          var is_lawyer = user_task[i];
        }
      }

      console.log(lawyer[0]?.asociations_relation);
      setFormValues({
        userRolId: lawyer[0]?.rol_relation?.id
          ? lawyer[0]?.rol_relation
          : { id: 0, type: "Seleccionar" },
        companyId: lawyer[0]?.company_relation?.id
          ? lawyer[0]?.company_relation
          : { id: 0, company_name: "Seleccionar" },
        // office: lawyer[0]?.offices_relation?.id
        //   ? lawyer[0]?.offices_relation
        //   : { id: 0, office_name: "Seleccionar" },
        userEmail: lawyer[0]?.email ? lawyer[0]?.email : "",
        userName: lawyer[0]?.name ? lawyer[0]?.name : "",
        userSurname: lawyer[0]?.surname ? lawyer[0]?.surname : "",
        userAddress: lawyer[0]?.address ? lawyer[0]?.address : "",
        userPostalCode: lawyer[0]?.postalcode ? lawyer[0]?.postalcode : "",
        userDocument: lawyer[0]?.nif ? lawyer[0]?.nif : "",
        userPhone: lawyer[0]?.phone ? lawyer[0]?.phone : "",
        provinceName: lawyer[0]?.provinces_relation?.provincia
          ? lawyer[0]?.provinces_relation
          : { id_provincia: 0, provincia: "Seleccionar" },
        association: lawyer[0]?.asociations_relation?.id
          ? lawyer[0]?.asociations_relation
          : { id: 0, asoc_name: "Seleccionar" },
        userTasks: is_lawyer ? is_lawyer : { id: 0, nombre: "Ninguno" },
        valCaseTypeForm: lawyer[0]?.notas ? lawyer[0]?.notas : "",
      });

      console.log(companies);

      setOptions({
        userRol: [{ type: "Seleccionar", ...defaultOptions }, ...roles],
        companies: [
          { company_name: "Seleccionar", ...defaultOptions },
          ...companies,
        ],
        status: [
          { nombre: "Ninguno", id: 0 },
          { nombre: "Abogado", id: 1 },
          { nombre: "Perito", id: 2 },
        ],
        provinces: [
          { provincia: "Seleccionar", id_provincia: 0 },
          ...provinces,
        ],
        // zones: [{ zona: "Seleccionar", ...defaultOptions }, ...zones],
      });

      setUserLogged(user_logged);
      filterDataByCompany(lawyer[0].company_relation?.id);
    } catch (error) {
      console.log(error);
    } finally {
      setFlag(false); // Asegurarse de desactivar la bandera en caso de error o éxito
    }
  };

  // Form submit handler
  const handleUsersFormInformation = async () => {
    const isValid = validateFields();

    if (isValid) {
      const formData = new FormData();

      const entries = [
        ["id", userId],
        ["type", formValues?.userRolId?.id],
        ["company_id", formValues?.companyId?.id],
        // ["office_id", formValues?.office?.id],
        ["email", formValues?.userEmail],
        ["name", formValues?.userName],
        ["surname", formValues?.userSurname],
        ["address", formValues?.userAddress],
        ["postalcode", formValues?.userPostalCode],
        ["nif", formValues?.userDocument],
        ["phone", formValues?.userPhone],
        ["province", formValues?.provinceName.provincia],
        ["asociation", formValues?.association.id],
        ["is_lawyer", formValues?.userTasks.id],
        ["notas", formValues?.valCaseTypeForm],
      ];

      console.log(entries);

      entries.forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });

      const queryUrl = `${process.env.REACT_APP_API_URL}/updatelawyer`;

      Swal.fire({
        title: "¿Desea guardar los cambios?",
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        confirmButtonText: "Guardar",
        denyButtonText: `Volver`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await api.post(queryUrl, formData);

            console.log(response);

            if (response.data.error) {
              Swal.fire({
                title: "¡No se guardaron los cambios!",
                icon: "error",
                text: "Por favor intentelo nuevamente",
                confirmButtonColor: "#1ab394",
              });
            } else {
              Swal.fire({
                title: "¡Guardado!",
                icon: "success",
                showDenyButton: false,
                confirmButtonColor: "#1ab394",
                allowEscapeKey: true, //  Permite cerrar con Escape
                allowOutsideClick: false, // opcional: no cerrar al dar click afuera
              }).then((result) => {
                if (result.isConfirmed) {
                  // Aquí después de guardar los cambios
                  navigate("/usuarios/ver?id=" + userId);
                } else if (result.isDenied) {
                  navigate("/usuarios");
                }
              });
            }
          } catch (error) {
            console.log(error);
          }
        } else if (result.isDenied) {
          Swal.fire("¡Los cambios no han sido guardados!", "", "info");
        }
      });
    } else {
      showValidationErrors();
    }
  };

  // Validate required fields
  const validateFields = () => {
    const requiredFields = [
      { value: formValues.companyId?.id, name: "Empresa" },
      { value: formValues.userRolId?.id, name: "Tipo de usuario" },
      { value: formValues.userEmail, name: "Email" },
      { value: formValues.userName, name: "Nombre" },
      { value: formValues.userSurname, name: "Apellido" },
    ];

    return requiredFields.every(
      (field) =>
        field.value !== "" &&
        field.value !== null &&
        field.value !== undefined &&
        field.value !== 0,
    );
  };

  const showValidationErrors = () => {
    const requiredFields = [
      { value: formValues.companyId?.id, name: "Empresa" },
      { value: formValues.userRolId?.id, name: "Tipo de usuario" },
      { value: formValues.userEmail, name: "Email" },
      { value: formValues.userName, name: "Nombre" },
      { value: formValues.userSurname, name: "Apellido" },
    ];

    const missingFields = requiredFields
      .filter(
        (field) =>
          field.value === "" ||
          field.value === null ||
          field.value === undefined ||
          field.value === 0,
      )
      .map((field) => `<li>${field.name}</li>`)
      .join("");

    Swal.fire({
      title: "¡Campos incompletos!",
      icon: "error",
      html: `<div style="text-align: start;">Por favor complete los siguientes campos:<ul>${missingFields}</ul></div>`,
      confirmButtonColor: "#1ab394",
    });
  };

  // SET VARIABLES
  useEffect(() => {
    getDataList(process.env.REACT_APP_API_URL);
  }, []);

  useEffect(() => {
    const loadOptions = (key) => {
      if (loadingOptions[key]) {
        setTimeout(() => {
          // Aquí deberías obtener los datos de options de alguna fuente externa si es necesario
          setOptions((prevOptions) => ({
            ...prevOptions,
            [key]: options[key], // Asumiendo que tienes los datos cargados en options[key]
          }));
        }, 1000); // Tiempo de espera para simular carga
      }
    };

    Object.keys(openOptions).forEach(loadOptions);
  }, [loadingOptions, openOptions]);

  const fieldsConfig = useMemo(
    () => [
      {
        type: "autocomplete",
        id: "companyId",
        label: "Empresa",
        onChange: (value) => {
          setFormValues((prev) => ({
            ...prev,
            companyId: value ? value : null,
          }));
          filterDataByCompany(value?.id || 0, true);
        },
        open: openOptions.companies,
        onOpen: () => setOpenOptions((prev) => ({ ...prev, companies: true })),
        onClose: () =>
          setOpenOptions((prev) => ({ ...prev, companies: false })),
        options: options.companies || [], // Asigna un arreglo vacío si options.companies es undefined
        loading: loadingOptions.companies,
        getOptionLabel: (option) => option.company_name ?? "Seleccionar",
        show: true,
      },
      {
        type: "autocomplete",
        id: "userRolId",
        label: "Tipo de usuario",
        onChange: (value) => {
          setFormValues((prev) => ({
            ...prev,
            userRolId: value ? value : null,
          }));
        },
        open: openOptions.userRol,
        onOpen: () => setOpenOptions((prev) => ({ ...prev, userRol: true })),
        onClose: () => setOpenOptions((prev) => ({ ...prev, userRol: false })),
        options: options.userRol,
        loading: loadingOptions.userRol,
        getOptionLabel: (option) => option.type ?? "Seleccionar",
        show: true,
      },
      // {
      //   type: "autocomplete",
      //   id: "office",
      //   label: "Despachos",
      //   onChange: (value) => {
      //     setFormValues((prev) => ({
      //       ...prev,
      //       office: value ? value : null,
      //     }));
      //   },
      //   open: openOptions.offices,
      //   onOpen: () => setOpenOptions((prev) => ({ ...prev, offices: true })),
      //   onClose: () => setOpenOptions((prev) => ({ ...prev, offices: false })),
      //   options: options.offices,
      //   loading: loadingOptions.offices,
      //   getOptionLabel: (option) => option.office_name ?? "Seleccionar",
      //   show: true,
      //   disabled: flagCompanySelected,
      // },
      {
        type: "autocomplete",
        id: "provinceName",
        label: "Provincia",
        onChange: (value) =>
          setFormValues((prev) => ({
            ...prev,
            provinceName: value ? value : null,
          })),
        open: openOptions.provinces,
        onOpen: () => setOpenOptions((prev) => ({ ...prev, provinces: true })),
        onClose: () =>
          setOpenOptions((prev) => ({ ...prev, provinces: false })),
        options: options.provinces,
        loading: loadingOptions.provinces,
        getOptionLabel: (option) => option.provincia ?? "Seleccionar",
        show: true,
      },
      {
        type: "autocomplete",
        id: "association",
        label: "Asociación",
        onChange: (value) =>
          setFormValues((prev) => ({
            ...prev,
            association: value ? value : null,
          })),
        open: openOptions.associations,
        onOpen: () =>
          setOpenOptions((prev) => ({ ...prev, associations: true })),
        onClose: () =>
          setOpenOptions((prev) => ({ ...prev, associations: false })),
        options: options.associations,
        loading: loadingOptions.associations,
        getOptionLabel: (option) => option.asoc_name ?? "Seleccionar",
        show: true,
        disabled: flagCompanySelected,
      },
      {
        type: "autocomplete",
        id: "userTasks",
        label: "Tareas de",
        onChange: (value) =>
          setFormValues((prev) => ({
            ...prev,
            userTasks: value ? value : null,
          })),
        open: openOptions.status,
        onOpen: () => setOpenOptions((prev) => ({ ...prev, status: true })),
        onClose: () => setOpenOptions((prev) => ({ ...prev, status: false })),
        options: options.status,
        loading: loadingOptions.status,
        getOptionLabel: (option) => option.nombre ?? "Seleccionar",
        show: true,
      },
      {
        type: "text",
        id: "userEmail",
        label: "Email",
        onChange: (e) =>
          setFormValues((prev) => ({ ...prev, userEmail: e.target.value })),
        show: true,
      },
      {
        type: "text",
        id: "userName",
        label: "Nombre",
        onChange: (e) =>
          setFormValues((prev) => ({ ...prev, userName: e.target.value })),
        show: true,
      },
      {
        type: "text",
        id: "userSurname",
        label: "Apellido",
        onChange: (e) =>
          setFormValues((prev) => ({ ...prev, userSurname: e.target.value })),
        show: true,
      },
      {
        type: "text",
        id: "userAddress",
        label: "Dirección",
        onChange: (e) =>
          setFormValues((prev) => ({ ...prev, userAddress: e.target.value })),
        show: true,
      },
      {
        type: "text",
        id: "userPostalCode",
        label: "Código Postal",
        onChange: (e) =>
          setFormValues((prev) => ({
            ...prev,
            userPostalCode: e.target.value,
          })),
        show: true,
      },
      {
        type: "text",
        id: "userDocument",
        label: "NIF/Pasaporte",
        onChange: (e) =>
          setFormValues((prev) => ({ ...prev, userDocument: e.target.value })),
        show: true,
      },
      {
        type: "text",
        id: "userPhone",
        label: "Teléfono",
        onChange: (e) =>
          setFormValues((prev) => ({ ...prev, userPhone: e.target.value })),
        show: true,
      },
      {
        type: "textarea",
        id: "valCaseTypeForm",
        label: "Notas",
        onChange: (e) =>
          setFormValues((prev) => ({
            ...prev,
            valCaseTypeForm: e.target.value,
          })),
        show: true,
      },
    ],
    [flagCompanySelected, openOptions, options, loadingOptions],
  );

  //////////////////// FILTER BY COMPANY  ///////////////////////
  const filterDataByCompany = async (
    company_id,
    flagFromCompanyInput = false,
  ) => {
    console.log(company_id);
    console.log(flagFromCompanyInput);

    if (company_id && company_id !== 0) {
      try {
        let queryUrl = `${process.env.REACT_APP_API_URL}/users/searchdatabycompany`;

        const response = await api.post(queryUrl, { company: company_id });

        if (response) {
          const {
            // offices = [],
            associations = [],
          } = response.data;

          setOptions((prevOptions) => ({
            ...prevOptions,
            // offices: [{ office_name: "Seleccionar", id: 0 }, ...offices],
            associations: [
              { asoc_name: "Seleccionar", id: 0 },
              ...associations,
            ],
          }));

          if (flagFromCompanyInput) {
            setFormValues((prev) => ({
              ...prev,
              // office: { office_name: "Seleccionar", id: 0 },
              association: { asoc_name: "Seleccionar", id: 0 },
            }));
          }

          setFlagCompanySelected(false);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      // Si no hay empresa seleccionada, limpiar las opciones y bloquear los campos
      setOptions((prevOptions) => ({
        ...prevOptions,
        // offices: [{ office_name: "Seleccionar", id: 0 }],
        associations: [{ asoc_name: "Seleccionar", id: 0 }],
      }));

      setFormValues((prev) => ({
        ...prev,
        // office: { office_name: "Seleccionar", id: 0 },
        association: { asoc_name: "Seleccionar", id: 0 },
      }));

      setFlagCompanySelected(true);
    }
  };

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Usuarios" subTitle="Editar" />

      {flag && <LinearProgress color="success" />}
      <Fade in={!flag} timeout={800}>
        <div className="formMainContainer">
          <Grid
            container
            style={{ textAlign: "center" }}
            className="fontSize"
            p={2}>
            {fieldsConfig?.map(
              (field) =>
                field.show && (
                  <Fragment key={field.id}>
                    {" "}
                    {/* Añade el key aquí */}
                    {field.type === "autocomplete" ? (
                      <Grid item xs={6} sx={{ padding: "5px" }}>
                        <Autocomplete
                          value={formValues[field.id]}
                          options={field.options || []} // Asegúrate de que sea un array
                          loading={field.loading}
                          open={field.open}
                          onOpen={field.onOpen}
                          disabled={field.disabled}
                          onClose={field.onClose}
                          onChange={(event, value) => field.onChange(value)}
                          getOptionLabel={field.getOptionLabel}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={field.label}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <Fragment>
                                    {params.InputProps.endAdornment}
                                  </Fragment>
                                ),
                                form: {
                                  autoComplete: "off", // Desactiva las sugerencias del navegador en el formulario
                                },
                              }}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password", // Truco para evitar que los navegadores activen el autofill
                              }}
                            />
                          )}
                        />
                      </Grid>
                    ) : field.type === "text" ? (
                      <Grid item xs={6} sx={{ padding: "5px" }} key={field.id}>
                        <TextField
                          value={formValues[field.id]}
                          label={field.label}
                          onChange={field.onChange}
                          variant="outlined"
                          autoComplete="new-password" // Desactiva el autofill general
                          fullWidth
                          size="small"
                          inputProps={{
                            maxLength:
                              field.id === "userPostalCode" ? 10 : undefined,
                          }}
                        />
                      </Grid>
                    ) : field.type === "textarea" ? (
                      <Grid item xs={12} sx={{ padding: "5px" }} key={field.id}>
                        <FormControl style={{ width: "100%" }}>
                          <FormLabel sx={{ textAlign: "left" }}>
                            Observaciones
                          </FormLabel>
                          <textarea
                            value={formValues[field.id]}
                            style={{
                              height: "100px",
                              resize: "none",
                              padding: "6px 13px",
                              fontSize: "15px",
                              borderRadius: "4px",
                              border: "1px solid rgba(128, 128, 128, 0.35)",
                            }}
                            onChange={field.onChange} // Asignar la función onChange
                          />
                        </FormControl>
                      </Grid>
                    ) : null}
                  </Fragment>
                ),
            )}
          </Grid>
          <Grid container p={2}>
            <ButtonGroup
              sx={{
                width: "100%",
              }}>
              <Button
                onClick={handleUsersFormInformation}
                color="info"
                variant="contained"
                size="small"
                sx={{
                  width: "100%",
                  fontWeight: "700",
                }}>
                <Topic style={{ marginRight: "10px" }} />
                Guardar
              </Button>
              <Button
                onClick={() => goView("usuario", userId)}
                variant="outlined"
                color="success"
                size="small"
                sx={{
                  width: "100%",
                }}>
                Ver usuario
              </Button>
              <Button
                onClick={() => goTable("usuarios", "Usuarios")}
                variant="outlined"
                color="error"
                size="small"
                sx={{
                  width: "100%",
                }}>
                Tabla
              </Button>
            </ButtonGroup>
          </Grid>
        </div>
      </Fade>
    </div>
  );
};

export default Editar;
